import type { GetServerSidePropsResult, NextPage } from 'next';
import { getPageCounter } from 'shared/prometheus/prometheus';
import { fetchOffers } from '@/api/fetcher';
import { ResultPageLayout } from '@/components/ResultPageLayout';
import { feConfig } from '@/config';
import { browserQueryParamsToFilters, filtersToApiQueryParams } from '@/lib/utils/queryParamFilterConversions';
import { runAllMiddlewares } from '@/server/middleware';
import { actions as filterActions } from '@/state/filterActions';
import { actions as resultActions } from '@/state/resultActions';
import { wrapper } from '@/state/store';

const ResultPage: NextPage = (props) => {
    wrapper.useHydration(props);

    return <ResultPageLayout />;
};

export const getServerSideProps = wrapper.getServerSideProps(
    (store) =>
        // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        async ({ req, res, query }): Promise<GetServerSidePropsResult<any>> => {
            if (!query.skipSSRData) {
                const props = await runAllMiddlewares(req, res, query);

                const filters = browserQueryParamsToFilters(query);
                store.dispatch(filterActions.filter(filters));

                const { statusCode, data } = await fetchOffers(filtersToApiQueryParams(filters));
                if (statusCode === 200) {
                    store.dispatch(resultActions.setResults(data));
                } else {
                    store.dispatch(resultActions.setError());
                }
                getPageCounter().inc({ app: 'pale-pp-web', page: 'result' });
                return { props: { ...props, config: feConfig } };
            }
            return { props: { config: feConfig } };
        },
);

export default ResultPage;
